import { render, staticRenderFns } from "./RecL.vue?vue&type=template&id=1999c236"
import script from "./RecL.vue?vue&type=script&lang=js"
export * from "./RecL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports